import { useContext } from 'react';

import { LocalizationContext } from '../contexts/LocalizationScope';
import useLanguage from 'packages/kakapo-ui-application/hooks/useLanguage';

export default function useLocalize() {
	const context = useContext(LocalizationContext);
	const defaultLanguage = useLanguage();
	const language = context?.languageID ? { id: context.languageID } : defaultLanguage;

	function localize<T extends { languageID: string }>(items: T[], defaultValue?: T): T {
		const optimized = items.filter((item: { languageID: string; text?: any }) => {
			if ('text' in item && typeof item.text === 'string') {
				return item.text.length > 0;
			}

			return true;
		});

		return (
			optimized.find((item) => item.languageID === language.id) ??
			defaultValue ??
			optimized[0] ??
			items[0]
		);
	}

	return { localize, language };
}
